import ReactSelect, { Async } from "react-select";
import { createSelect } from "./createSelect";
export var AsyncSelect = createSelect(Async);
export var Select = createSelect(ReactSelect);
